import {AlertController, NavController, Keyboard} from 'ionic-angular';
import {Component} from '@angular/core';
import {UserService} from '../../services/user.services';
import {AppConfigService} from '../../services/appConfig.service';
import {AppDialog} from "../../component/appDialog";
import {BalanceChangeListPage} from "../balanceChangeList/balanceChangeList";
import { LoginPage } from '../login/login';

//和下级投注样式差不多历史一样
@Component({
  templateUrl: 'balanceChangeSearch.html',
  selector: 'agency-user-zb-search-page',
})
export class BalanceChangeSearchPage {
  //账变类型
  typeid: number = -1;
  statusid: number = -1;
  starttime: any;
  wallettype = LoginPage.wallettype
  endtime: string;
  //编号
  wid: string;
  //账变编号
  id: string;
  typelist: any = [];
  statuslist: any = [];

  constructor(private keyboard: Keyboard,private nav: NavController, private alertCtrl: AlertController, private userService: UserService) {
    this.initService();
  }

  initService() {
    this.userService.balanceChangeInit(undefined, this.alertCtrl).then(data=> {
      if (!data["msg"]) {
        this.typelist = data["typelist"];
        if(LoginPage.wallettype == 1) {
          this.statuslist = data["statuslist"];
        }
        
        this.starttime = data["starttime"].replace(" ", "T");
        this.endtime = data["endtime"].replace(" ", "T");
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }

  searchFn() {
    let requestData: any = {
      type: this.typeid,
      wid: this.wid,
      starttime: this.starttime.replace("T", ' ').substr(0, 19),
      endtime: this.endtime.replace("T", ' ').substr(0, 19),
      id: this.id,
      status : Number(this.statusid)
    };
    // if(this.statusid != -1 ){
      
    // }
    this.userService.balanceChangeSearch(requestData, this.alertCtrl).then(data=> {
      if (!data["msg"]) {

        this.nav.push(BalanceChangeListPage, {
          requestData: requestData,
          data: data
        });
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }

  ionViewWillLeave(){
    this.keyboard.close();
  }
}



// WEBPACK FOOTER //
// ./src/pages/balanceChangeSearch/balanceChangeSearch.ts